import copy from 'copy-to-clipboard';
import {MutableRefObject, useEffect, useRef, useState} from 'react';

const DEFAULT_RESET_MS = 2000;

function clearTimeoutRef(
  ref: MutableRefObject<ReturnType<typeof setTimeout> | null>
) {
  if (ref.current !== null) {
    clearTimeout(ref.current);
    ref.current = null;
  }
}

/**
 * Copies text to the clipboard and tracks a short "copied" state for UI feedback.
 * Clears the timeout on unmount to avoid leaks.
 */
function useCopyToClipboardWithFeedback(resetMs = DEFAULT_RESET_MS) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => clearTimeoutRef(timeoutRef);
  }, []);

  const copyToClipboard = (text: string) => {
    copy(text);
    setCopied(true);
    clearTimeoutRef(timeoutRef);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      timeoutRef.current = null;
    }, resetMs);
  };

  return {copied, copyToClipboard};
}

export default useCopyToClipboardWithFeedback;
